import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	companyManagedProject: {
		id: 'spa-apps-sidebar-core.multi-project-menu.company-managed-project',
		defaultMessage: "You're in a company-managed project",
		description: 'This is what the user sees when they are on a company-managed project',
	},
	navigationLabel: {
		id: 'spa-apps-sidebar-core.multi-project-menu.navigation-label',
		defaultMessage: 'Side',
		description: 'Accessible label used to describe the side navigation element',
	},
	teamManagedProject: {
		id: 'spa-apps-sidebar-core.multi-project-menu.team-managed-project',
		defaultMessage: "You're in a team-managed project",
		description: 'This is what the user sees when they are on a team-managed (next-gen) project',
	},
	viewAllStarred: {
		id: 'spa-apps-sidebar-core.multi-project-menu.view-all-starred',
		defaultMessage: 'View all starred projects',
		description:
			'Label of the link to the project directory page when there are more starred projects available.',
	},
});
